import CheckboxIndicator from "./CheckboxIndicator";

export default CheckboxIndicator;
